import angular from 'angular';

// Component
import component from './loginScreen.component';

// Load all services
import '../../../lib/service';

// Dependencies
import translation from '../../../lib/translation';
import errorList from '../../../lib/components/errorList';

const moduleName = 'staff.loginScreen';
let module = angular.module(moduleName, [
  errorList.name,
  'recaps.services',
  translation,
]);

module.component('loginScreen', component);

export default module;
